const extractIframe = (embed: string) => {
  const iframeRegex = /<iframe\b[^>]*>(.*?)<\/iframe>/i;
  let iframeHtml = '';

  const match = embed.match(iframeRegex);

  if(match) {
    iframeHtml = match[0];
  }
  
  return iframeHtml;
}

export default extractIframe;